import React, {useState} from 'react';
import tooltipCss from '../../styles/myAccount/tooltip.module.scss';

const ToolTip = (props) => {

  const { toolTip, tooltipdata, tooltipsmbl, parentCss } = props;
  const [showInfo, setShowInfo] = useState(false);

  return (<>
    <a
      className={` position-relative tg-svreg  d-block ${parentCss['gfs-24']} gfs-md-32 ${parentCss['gfw-7']} position-absolute tru-mma-main-wrapper--summary ${parentCss["service-tooltip"]} text-center text-white`}
      title=''
      onMouseEnter={() => setShowInfo(true)} 
      onMouseLeave={() => setShowInfo(false)} 
    >
      {tooltipsmbl}
      {showInfo && <span className={`${tooltipCss['tooltiptextReg']}`}>
        <div className={`${tooltipCss['tooltip-head']}`}>{toolTip}</div>
        <span className={`${tooltipCss['tooltip-text']}`}>{tooltipdata}</span>
      </span>}
    </a>
  </>);
}

export default ToolTip;